import { render, staticRenderFns } from "./Content0.vue?vue&type=template&id=34c863ed&scoped=true"
import script from "./Content0.vue?vue&type=script&lang=js"
export * from "./Content0.vue?vue&type=script&lang=js"
import style0 from "./Content0.vue?vue&type=style&index=0&id=34c863ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c863ed",
  null
  
)

export default component.exports